
import React from "react";
import { AlertTriangle } from "lucide-react";

const ReportsTab = () => {
  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Reported Content</h2>
      
      <div className="text-center py-12 bg-secondary/30 rounded-lg">
        <AlertTriangle className="mx-auto h-12 w-12 text-muted-foreground mb-4" />
        <p className="text-muted-foreground">No reported content at this time.</p>
      </div>
    </div>
  );
};

export default ReportsTab;
